export default __webpack_public_path__ + "static/media/project.9f5cab14.svg";